<template>
  <div class="app-background">
    <v-progress-circular indeterminate size="48" color="accent"/>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
  name: 'Loading',
  computed: {
    ...mapGetters('auth', ['authLoaded', 'authUserUid']),
    ...mapGetters('loading', ['appLoaded']),
    redirect() {
      return this.$route.params.redirect ? this.$route.params.redirect : {name: 'home'};
    }
  },
  watch: {
    authLoaded: {
      handler(auth) {
        // if not logged in, otherwise wait for app load
        if (auth && !this.authUserUid) {
          this.$logger.log('firebase initialised, redirecting to: ', this.redirect);
          // make sure all the getters have updated before redirecting
          this.$nextTick(() => {
            this.$router.push(this.redirect)
                .catch(() => {
                  // no error is ever thrown just show the call has been aborted
                  this.$logger.info('aborted');
                });
          });
        }
      },
      immediate: true
    },
    appLoaded: {
      handler(loaded) {
        if (loaded) {
          this.$logger.log('app loaded, redirecting to: ', this.redirect);
          // make sure all the getters have updated before redirecting
          this.$nextTick(() => {
            this.$router.push(this.redirect)
                .catch(() => {
                  // no error is ever thrown just show the call has been aborted
                  this.$logger.info('aborted');
                });
          });
        }
      },
      immediate: true
    }
  }
};
</script>

<style scoped>
  .app-background {
    height: 800px;
    width: 1280px;
    position: relative;
  }

  .app-background div {
    --size: 48px;
    position: absolute;
    top: calc(400px - var(--size));
    left: calc(640px - var(--size));
  }
</style>
